module.exports = __webpack_public_path__ + "static/media/sentakumonoHoshi.f9869013.png";